import { render, staticRenderFns } from "./ShopStore.vue?vue&type=template&id=3a6538ee&scoped=true"
import script from "./ShopStore.vue?vue&type=script&lang=js"
export * from "./ShopStore.vue?vue&type=script&lang=js"
import style0 from "./ShopStore.vue?vue&type=style&index=0&id=3a6538ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6538ee",
  null
  
)

export default component.exports